import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Card, CardContent, Grid, Step, StepLabel, Stepper, Typography, Modal } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TakeAction from "../../Modals/takeaction";

const orderTimeline = [
    {
        title: "Order Placed",
        date: "12/7/2025, 4:47:53 PM",
        completed: true,
        icon: <RadioButtonUncheckedIcon />,
    },
    {
        title: "Order Confirmed",
        date: "12/7/2025, 4:47:53 PM",
        completed: true,
        icon: <CheckCircleIcon />,
    },
    {
        title: "Order Shipped",
        date: "12/9/2025, 4:47:53 PM",
        tracking: "TRK-10001",
        completed: true,
        icon: <LocalShippingIcon />,
    },
    {
        title: "Order Delivered",
        date: "12/11/2025, 4:47:53 PM",
        completed: true,
        icon: <CheckCircleIcon />,
    },
];


const ViewOrderManagement: React.FC = () => {
    const isDelivered = true; // toggle based on order status
    const navigate = useNavigate();

    // Static order data


    // Map order status to workflow steps
    const workflowSteps = [
        "Pending",
        "Shipped",
        "Delivered",
        "Payout Pending",
        "Cancelled / Returned",
        "Payout Released",
        "Paid",
    ];
    const order = {
        id: "ORD12345",

        vendor: {
            name: "TechHub Electronics",
            email: "support@techhub.com",
            phone: "+971 55 123 4567",
            image: "/static/images/user_placeholder.png",
        },

        customerName: "John Doe",
        customerPhone: "123-456-7890",
        orderDateTime: "2025-11-19 14:30",
        amount: "250.00",
        method: "Credit Card",
        status: "Shipped",
        category: "Electronics",
        subCategory: "Mobile Phones",
        quantity: 2,
        expectedDelivery: "2025-11-25",
        notes: "Handle with care",
        paymentStatus: "Paid",
        courier: "FedEx",
        trackingNumber: "FX123456789",
        pickupDateTime: "2025-11-19 16:00",

        items: [
            {
                name: "iPhone 14",
                amount: "1200.00",
                quantity: 1,
                sku: "IPH14",
                commission: 10,
                netAmount: "1080.00",
                image: "/static/images/placeholder.png",
            },
            {
                name: "Samsung Galaxy S21",
                amount: "1000.00",
                quantity: 1,
                sku: "SGS21",
                commission: 8,
                netAmount: "920.00",
                image: "/static/images/placeholder.png",
            },
        ],

        activityLog: [
            { time: "2025-11-19 14:35", action: "Order placed", actor: "Customer" },
            { time: "2025-11-19 15:00", action: "Order shipped", actor: "Admin" },
        ],
    };

    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const [openTrackingModal, setOpenTrackingModal] = useState(false);
    const handleCloseTrackingModal = () => {
        setOpenTrackingModal(false);
    };

    // Tracking details data
    const trackingDetails = [
        {
            id: 1,
            status: "Dispatched",
            location: "Dubai Warehouse, Al Quoz Industrial Area",
            address: "Building 15, Warehouse A, Dubai, UAE",
            timestamp: "12/9/2025, 4:47:53 PM",
            description: "Order has been dispatched from vendor warehouse",
            completed: true,
        },
        {
            id: 2,
            status: "In Transit",
            location: "Dubai Sorting Facility",
            address: "Dubai Logistics Hub, Jebel Ali, Dubai, UAE",
            timestamp: "12/9/2025, 8:30:15 PM",
            description: "Order reached sorting facility",
            completed: true,
        },
        {
            id: 3,
            status: "In Transit",
            location: "Abu Dhabi Distribution Center",
            address: "Abu Dhabi Logistics Park, Mussafah, Abu Dhabi, UAE",
            timestamp: "12/10/2025, 2:15:42 PM",
            description: "Order arrived at distribution center",
            completed: true,
        },
        {
            id: 4,
            status: "Out for Delivery",
            location: "Delivery Vehicle",
            address: "En route to delivery address",
            timestamp: "12/11/2025, 9:00:00 AM",
            description: "Order is out for delivery",
            completed: true,
        },
        {
            id: 5,
            status: "Delivered",
            location: "Customer Address",
            address: "123 Main Street, Abu Dhabi, UAE",
            timestamp: "12/11/2025, 4:47:53 PM",
            description: "Order successfully delivered to customer",
            completed: true,
        },
    ];

    return (
        <>
            <div className="view_order_page">
                <div className="main_title">
                    <h1>View Order</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                        <button onClick={() => navigate("/order-management")}>
                            Order Management
                        </button>{" "}
                        - View
                    </p>
                </div>

                {/* Order Summary */}
                <div className="cards view_page">
                    <h3>Order Summary</h3>
                    <div className="gap_p">
                        <div className="w_33">
                            <h6>Order ID</h6>
                            <p>{order.id}</p>
                        </div>
                        <div className="w_33">
                            <h6>Order Date & Time</h6>
                            <p>{order.orderDateTime}</p>
                        </div>
                        <div className="w_33">
                            <h6>Payment Method</h6>
                            <p>{order.method}</p>
                        </div>
                        <div className="w_33">
                            <h6>Payment Status</h6>
                            <p>{order.paymentStatus || "Pending"}</p>
                        </div>
                        <div className="w_33">
                            <h6>Total Amount</h6>
                            <p>{order.amount}</p>
                        </div>
                        <div className="w_33">
                            <h6>Admin Commission</h6>
                            <p>20</p>
                        </div>
                        <div className="w_33">
                            <h6>Vendor Net Payout </h6>
                            <p>100</p>
                        </div>
                        <div className="w_33">
                            <h6>ETA </h6>
                            <p>16-02-2025</p>
                        </div>
                    </div>
                </div>
                {/* Items Details */}
                <div className="cards">
                    <CardContent>
                        <h3 >Items Details</h3>
                        <Grid container spacing={2}>
                            {order.items?.map((item, idx) => (
                                <Grid item xs={12} md={6} key={idx}>
                                    <Card variant="outlined" sx={{ display: "flex", padding: 1 }}>
                                        <Box sx={{ width: 100, height: 100, mr: 2 }}>
                                            <img
                                                src={item.image || "/static/images/placeholder.png"}
                                                alt={item.name}
                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                            />
                                        </Box>
                                        <Box>
                                            <Typography variant="subtitle1">{item.name}</Typography>
                                            <Typography variant="body2">Amount: ${item.amount} | Qty: {item.quantity}</Typography>
                                            <Typography variant="body2">SKU: {item.sku}</Typography>
                                            <Typography variant="body2">Commission: {item.commission}%</Typography>
                                            <Typography variant="body2">Vendor Net: ${item.netAmount}</Typography>
                                        </Box>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </CardContent>
                </div>
                <div className="cards view_page order_timeline">
                    <h3>Order Workflow <Button className="btn btn_primary sm" onClick={()=> setOpenModal(true)}>Take Action</Button> </h3>
                    <div className="flex12">
                        <div className="timeline">
                            {orderTimeline.map((item, index) => (
                                <div
                                    key={index}
                                    className={`timeline_item ${item.completed ? "completed" : ""}`}
                                >
                                    {/* Icon */}
                                    <div className="icon">
                                        {item.icon}
                                    </div>

                                    {/* Content */}
                                    <div className="content">
                                        <h4>{item.title}</h4>
                                        <span className="date">{item.date}</span>

                                        {item.tracking && (
                                            <div className="tracking">
                                                Tracking: <b 
                                                    className="tracking_link"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setOpenTrackingModal(true);
                                                    }}
                                                >{item.tracking}</b>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                        {isDelivered && (
                            <div className="delivery_image">
                                <h4>Order Delivered</h4>
                                <img
                                    src="/static/images/placeholder.png"
                                    alt="Order Delivered"
                                />
                            </div>
                        )}
                    </div>
                    {/* Delivered Image */}
                </div>

                {/* Delivery & Logistics */}
                <div className="cards view_page">
                    <h3>Delivery & Logistics</h3>
                    <div className="gap_p">
                        <div className="w_33">
                            <h6>Courier Name</h6>
                            <p>{order.courier || "-"}</p>
                        </div>
                        <div className="w_33">
                            <h6>Tracking Number</h6>
                            <p>{order.trackingNumber || "-"}</p>
                        </div>
                        <div className="w_33">
                            <h6>Pickup Date & Time</h6>
                            <p>{order.pickupDateTime || "-"}</p>
                        </div>
                    </div>
                </div>
                <div className="order_timeline">
                    <div className="flex12">

                        <div className="cards view_page">
                            <h3>Customer Details</h3>
                            <div className="gap_p view_page">
                                <div className="w_100 vew_img">
                                    <h6>User Image</h6>
                                    <figure>
                                        <img src="/static/images/user_placeholder.png" alt="" />
                                    </figure>
                                </div>
                                <div className="w_33">
                                    <h6>User Name</h6>
                                    <p>Jeo</p>
                                </div>
                                <div className="w_33">
                                    <h6>User Email</h6>
                                    <p>Jeogmail.com</p>
                                </div>
                                <div className="w_33">
                                    <h6>User Phone</h6>
                                    <p>892738623767</p>
                                </div>
                            </div>
                        </div>
                        {/* Vendor Details */}
                        <div className="cards view_page">
                            <h3>Vendor Details</h3>
                            <div className="gap_p view_page">
                                <div className="w_100 vew_img">
                                    <h6>Vendor Image</h6>
                                    <figure>
                                        <img
                                            src="/static/images/user_placeholder.png"
                                            alt="Vendor"
                                        />
                                    </figure>
                                </div>

                                <div className="w_33">
                                    <h6>Vendor Name</h6>
                                    <p>{order.vendor.name}</p>
                                </div>

                                <div className="w_33">
                                    <h6>Vendor Email</h6>
                                    <p>{order.vendor.email}</p>
                                </div>

                                <div className="w_33">
                                    <h6>Vendor Phone</h6>
                                    <p>{order.vendor.phone}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>






                {/* Activity Log */}
                <div className="cards view_page mt_20">
                    <h3>Activity Log</h3>
                    {order.activityLog?.length ? (
                        <ul>
                            {order.activityLog.map((log, idx) => (
                                <li key={idx}>
                                    <strong>{log.time}</strong>: {log.action} ({log.actor})
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p>No activity recorded.</p>
                    )}
                </div>

            </div>
            <TakeAction
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />

            {/* Tracking Details Modal */}
            <Modal
                className="modal rejectReason_modal"
                open={openTrackingModal}
                onClose={handleCloseTrackingModal}
            >
                <div className="modal-dialog take_action_modal" style={{ maxWidth: "700px" }}>
                    <div className="modal-body">
                        <div className="modal_title">
                            <h2>Tracking Details - TRK-10001</h2>
                            <button className="btn-close" onClick={handleCloseTrackingModal}>
                                <CloseIcon />
                            </button>
                        </div>

                        <div className="tracking_details_content">
                            <div className="tracking_header">
                                <div className="tracking_info">
                                    <h4>Courier: {order.courier}</h4>
                                    <p>Tracking Number: <b>{order.trackingNumber || "TRK-10001"}</b></p>
                                    <p>Order ID: <b>{order.id}</b></p>
                                </div>
                            </div>

                            <div className="tracking_timeline">
                                {trackingDetails.map((point, index) => (
                                    <div
                                        key={point.id}
                                        className={`tracking_point ${point.completed ? "completed" : ""} ${index === trackingDetails.length - 1 ? "last" : ""}`}
                                    >
                                        <div className="tracking_point_icon">
                                            <LocationOnIcon 
                                                style={{ 
                                                    color: point.completed ? "#22c55e" : "#cbd5e1",
                                                    fontSize: "24px"
                                                }} 
                                            />
                                            {index < trackingDetails.length - 1 && (
                                                <div className="tracking_line"></div>
                                            )}
                                        </div>
                                        <div className="tracking_point_content">
                                            <div className="tracking_status">
                                                <h5>{point.status}</h5>
                                                <span className="tracking_time">{point.timestamp}</span>
                                            </div>
                                            <div className="tracking_location">
                                                <p className="location_name">
                                                    <LocationOnIcon style={{ fontSize: "16px", marginRight: "4px", verticalAlign: "middle" }} />
                                                    {point.location}
                                                </p>
                                                <p className="location_address">{point.address}</p>
                                                <p className="location_description">{point.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ViewOrderManagement;
